<input type="file"
  multiple
  class="file-input"
  accept=".jpg, .jpeg, .png"
  (change)="onFilesSelected($event)"
  #filesUpload
  hidden>

@if (!isLoading) {
  <button mat-icon-button
    [disabled]="disabled"
    matTooltip="{{'attachments' | transloco}}"
    class="attach-file"
    (click)="openImageFilesChooser(filesUpload)">
    <mat-icon>attach_file</mat-icon>
    @if (selectedFiles.length) {
      <div>{{ selectedFiles.length }}</div>
    }
  </button>
}

@if (isLoading) {
  <div class="loader">
    <mat-progress-spinner
      color="accent"
      mode="determinate"
      diameter="40"
      strokeWidth="4"
      [value]="progress">
    </mat-progress-spinner>
    <div class="value">{{ progress }}%</div>
  </div>
}
